import PropTypes from 'prop-types';
import { useDirection, useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { Inline, Stack } from '@etg/wings';
import { bounds as boundsPropTypes } from '../trip-details/propTypes';
import { MULTI_STOP, ONE_WAY, RETURN } from '../../constants/tripTypesConstants';
import { resolveTripDates, resolveTripBounds } from '../trip-details/utils/format';

const tripTypeDatesStyles = css`
  color: #737373;
`;

const ShareTripFlightDetails = ({ bounds, type }) => {
  const { t } = useTranslation();
  const { isRTL } = useDirection();
  const resolvedDates = resolveTripDates(bounds);
  const resolvedBounds = resolveTripBounds(bounds, type);
  const tripTypeText = {
    RETURN: t('Air.Search.Return'),
    ONE_WAY: t('Air.Search.Oneway'),
  };
  const hasSameReturnDate =
    resolvedDates && resolvedDates.arrivalDate === resolvedDates.departureDate;

  return (
    <Stack data-testid="flight-details-wrapper" spacing={4}>
      <span>
        {resolvedBounds.map((bound) => (
          <div key={`${bound.origin}-${bound.destination}`}>
            {isRTL
              ? `${bound.destination} - ${bound.origin}`
              : `${bound.origin} - ${bound.destination}`}
          </div>
        ))}
      </span>
      <Inline className={tripTypeDatesStyles} spacing={4}>
        {type && <span>{tripTypeText[type] ?? t('Air.Search.MultiBound')}</span>}
        <span>{resolvedDates?.departureDate}</span>
        <span>-</span>
        {!hasSameReturnDate && resolvedDates.arrivalDate}
      </Inline>
    </Stack>
  );
};

ShareTripFlightDetails.propTypes = {
  bounds: boundsPropTypes,
  type: PropTypes.oneOf([MULTI_STOP, ONE_WAY, RETURN]),
};

export default ShareTripFlightDetails;
